const entity = 'dashboard'
const entitySingle = 'dashboard'
const tableIcon = 'cil-speedometer'

export {
  entity,
  entitySingle,
  tableIcon
}
